export let data = [
    // 0
    [
        {
            id:1,
            name_uz: "Robototexnika | 7 oy",
            name_ru: "Робототехника | 7 месяцев"
        },
        {
            id:2,
            name_uz: "Scratch | 3 oy",
            name_ru: "Scratch | 3 месяца"
        },
    ],
    // 1
    [
        {
            id:3,
            name_uz: "Kompyuter savodxonligi | 2 oy",
            name_ru: "Компьютерная грамотность | 2 месяца"
        },
    ],
    // 2
    [
        {
            id:4,
            name_uz: "Mobil o'yin yaratish | 3 oy",
            name_ru: "Создание мобильной игры | 3 месяца"
        },
        {
            id:5,
            name_uz: "Web dasturlash | 4 oy",
            name_ru: "Веб программирование | 4 месяца"
        },
    ],
    // 3
    [
        {
            id:6,
            name_uz: "Android dasturlash | 3 oy",
            name_ru: "Андроид-программирование | 3 месяца"
        }
    ],
];
export let item = [
    // 0
    [
        {
            id: 1,
            name_uz: "1 - bosqich | 1 oy",
            name_ru: "1 - этап | 1 месяц",
            child : [
                {
                    id:1,
                    detail_item_uz: "Robototexnika asoslari",
                    detail_item_ru: "Основы робототехники",
                },
                {
                    id:2,
                    detail_item_uz: "Lego mexanikasi bilan ishlash",
                    detail_item_ru: "Работа с Лего механикой",
                },
                {
                    id:3,
                    detail_item_uz: "Lego Mindstorm EV3",
                    detail_item_ru: "Лего Mindstorm EV3",
                }
            ]
        },
        {
            id: 2,
            name_uz: "2 - bosqich | 5 oy",
            name_ru: "2 - этап | 5 месяц",
            child: [
                {
                    id:1,
                    detail_item_uz: "Elektron va elektronika asoslari",
                    detail_item_ru: "Основы электроники и электроники",
                },
                {
                    id:2,
                    detail_item_uz: "Mikrokontroller bilan ishlash",
                    detail_item_ru: "Работа с микроконтроллерами",
                },
                {
                    id:3,
                    detail_item_uz: "Arduino kursi",
                    detail_item_ru: "Курс ардуино",
                }
            ]
        },
        {
            id: 3,
            name_uz: "3 - bosqich | 1 oy",
            name_ru: "3 - этап | 1 месяц",
            child: [
                {
                    id:1,
                    detail_item_uz: "3D modellashtirish",
                    detail_item_ru: "3D моделирование",
                },
                {
                    id:2,
                    detail_item_uz: "Murakkab mexanik modellarni ishlab chiqish",
                    detail_item_ru: "Разработка сложных механических моделей",
                },
                {
                    id:3,
                    detail_item_uz: "Dasturlash kursi",
                    detail_item_ru: "Курс программирования",
                }
            ]
        },
    ],
    // 1
    [
        {
            id: 1,
            name_uz: "1 - bosqich | 2 oy",
            name_ru: "1 - этап | 2 месяц",
            child : [
                {
                    id:1,
                    detail_item_uz: "Scratch dasturi interfeysi",
                    detail_item_ru: "Scratch интерфейс программного обеспечения",
                },
                {
                    id:2,
                    detail_item_uz: "Scratch muxitida ishni boshlash",
                    detail_item_ru: "Начните работу в среде нуля",
                },
                {
                    id:3,
                    detail_item_uz: "Scratch dasturini asosiy skriptlari",
                    detail_item_ru: "Базовые скрипты программы Scratch",
                }
            ]
        },
        {
            id: 2,
            name_uz: "2 - bosqich | 2 oy",
            name_ru: "2 - этап | 2 месяц",
            child : [
                {
                    id:1,
                    detail_item_uz: "Bir nechta obyektlar bilan ishlash. Ularning ishini sinxronlashtirish",
                    detail_item_ru: "Работа с несколькими объектами. Синхронизируйте их работу",
                },
                {
                    id:2,
                    detail_item_uz: "Mini-o'yinlarni yaratishda Scratch dasturidan foydalanish",
                    detail_item_ru: "Использование Scratch для создания мини-игр",
                },
                {
                    id:3,
                    detail_item_uz: "Ijodiy loyihalarni ishlab chiqish",
                    detail_item_ru: "Разработка творческих проектов",
                }
            ]
        },
    ],
    // 2
    [
        {
            id: 1,
            name_uz: "1 - bosqich | 1 oy",
            name_ru: "1 - этап | 1 месяц",
            child : [
                {
                    id:1,
                    detail_item_uz: "Buildbox dasturi imkoniyatlari",
                    detail_item_ru: "Варианты программы Buildbox",
                },
                {
                    id:2,
                    detail_item_uz: "Buildbox yordamchi vositalari bilan ishlash",
                    detail_item_ru: "Работа с утилитами Buildbox",
                },
                {
                    id:3,
                    detail_item_uz: "Buildbox dasturida o'yin yaratish",
                    detail_item_ru: "Создать игру в Buildbox",
                }
            ]
        },
        {
            id: 2,
            name_uz: "2 - bosqich | 2 oy",
            name_ru: "2 - этап | 2 месяц",
            child : [
                {
                    id:1,
                    detail_item_uz: " O'yinni APK format qilish",
                    detail_item_ru: "Отформатируйте игру APK",
                },
                {
                    id:2,
                    detail_item_uz: "Blender dasturi bilan tanishing",
                    detail_item_ru: "Знакомство с программой Blender",
                },
                {
                    id:3,
                    detail_item_uz: "O'yinni Google Play-ga joylash",
                    detail_item_ru: "Загрузите игру в Google Play",
                }
            ]
        }
    ],
    // 3
    [
        {
            id:1,
            detail_item_uz: "Dasturlash asoslari",
            detail_item_ru: "Основы программирования",
        },
        {
            id:2,
            detail_item_uz: "Web saytlar qurilish jarayoni",
            detail_item_ru: "Процесс создания сайта",
        },
        {
            id:3,
            detail_item_uz: "HTML & CSS",
            detail_item_ru: "HTML & CSS",
        },
        {
            id:4,
            detail_item_uz: "Sayt sxemasini qurish",
            detail_item_ru: "Составьте схему сайта",
        },
        {
            id:5,
            detail_item_uz: "Saytning ko'rinishini qilishda yangi texnologiyalardan foydalanish",
            detail_item_ru: "Использование новых технологий в дизайне сайта",
        },
        {
            id:6,
            detail_item_uz: "Javascript, Jquery",
            detail_item_ru: "Javascript, Jquery",
        },
        {
            id:7,
            detail_item_uz: "Real proektlar ustida ishlash",
            detail_item_ru: "Работа над реальными проектами",
        },
        {
            id:8,
            detail_item_uz: "Jamoa bo'lib ishlash qoidalari",
            detail_item_ru: "Правила работы в команде",
        },
    ],
    // 4
    [
        {
            id:1,
            detail_item_uz: "Dasturlash asoslari",
            detail_item_ru: "Основы программирования",
        },
        {
            id:2,
            detail_item_uz: "AndroidStudio'da ishlash",
            detail_item_ru: "Работать в AndroidStudio",
        },
        {
            id:3,
            detail_item_uz: "Dastur dizaynini yasash",
            detail_item_ru: "Создание дизайна программы",
        },
        {
            id:4,
            detail_item_uz: "Java dasturlash tili Java, OOP",
            detail_item_ru: "Язык программирования Java, ООП",
        },
        {
            id:5,
            detail_item_uz: "Real proektlar ustida ishlash",
            detail_item_ru: "Работа над реальными проектами",
        },
        {
            id:6,
            detail_item_uz: "Jamoa bo'lib ishlash",
            detail_item_ru: "Работы в команде",
        },
    ]
];
export let robot = [
    {
        id: 1,
        name_uz: "Matematika va fizika bo'limlarini o'rganamiz",
        name_ru: "Мы изучаем математический и физический факультеты",
        desc_uz: "Dasturlash va matematika bizning asosiy faoliyatimizdir.Biz Lego to'plamlari bilan mexanika bo'limini va Arduino-ni o'rganamiz",
        desc_ru: "Программирование и математика - наша основная деятельность. Мы изучаем механику и Arduino с наборами Lego.",
    },
    {
        id: 2,
        name_uz: "Dasturlash va informatika",
        name_ru: "Программирование и информатика",
        desc_uz: "Dasturlash faoliyatimizning asosiy qismlaridan biridir. Biz Lego bilan dasturlashni boshlaymiz - eng oddiy blok sxemasidan boshlab o'tamiz va keyinchalik yuqori darajali dasturlash tillari bilan ham shug'illanamiz",
        desc_ru: "Программирование — одна из ключевых частей нашей работы. Начинаем программировать с Лего - начинаем с простейшей блок-схемы и далее уже занимаемся языками программирования высокого уровня",
    },
    {
        id: 3,
        name_uz: "Mexanika (loyihalash asoslari)",
        name_ru: "Механика (основы дизайна)",
        desc_uz: "Lego o'quv to'plamlari bizga mexanizmlarning harakat tamoyilarini, transmissiya  nima ekanligi, va turli xildagi mexanizmlarni ishlashdagi boshlang'ich bilim va ko'nikmalarni beradi",
        desc_ru: "Учебные наборы Lego дают нам базовые знания и навыки в принципах движения механизмов, что такое трансмиссия и как управлять различными механизмами",
    },
    {
        id: 4,
        name_uz: "Fikrlashni rivojlantirish algoritmlash",
        name_ru: "Алгоритм развития мышления",
        desc_uz: "Mantiqiy vazifalar va jumboqlar yechishda taffakurni rivojlantirishga yordam beradi, javob izlash va xulosa chiqarish qobilyatini rivojlantiradi ",
        desc_ru: "Помогает развивать мышление при решении логических задач и головоломок, развивает умение искать ответы и делать выводы",
    },
    {
        id: 5,
        name_uz: "Jamoa bo'lib ishlashni o'rgatamiz",
        name_ru: "Учим работать в команде",
        desc_uz: "Jamoa bo'lib ishlash maqsadlarga samarali erishish uchun mihimdir. Raqobatbardoshlikni hibsga olgan holda bolaning bilim olishga qiziqishini oshirish orqali yaxshi natijalarga erishamiz",
        desc_ru: "Помогает развивать мышление при решении логических задач и головоломок, развивает умение искать ответы и делать выводы",
    },
];
export let game = [
    {
        id:1,
        name_uz: "Necha yoshdan o'rgansa bo'ladi?",
        name_ru: "С какого возраста можно учиться?",
        desc_uz: "Mobil o'yin yaratishni 11 yoshdan yuqori bolalar qiyinchiliksiz o'rgansa oladi",
        desc_ru: "Дети старше 11 лет могут без труда научиться создавать мобильные игры"
    },
    {
        id:2,
        name_uz: "Boshlashim uchun men superkuchga ega bo'lishim shartmi?",
        name_ru: "Должен ли я иметь сверхдержаву, чтобы начать?",
        desc_uz: "Boshlash uchun superkuchga ega bolishingiz shartmas. Boshlash uchun xoxish bo'lsa yetarli",
        desc_ru: "Вам не нужно иметь сверхдержаву, чтобы начать. Достаточно, если есть желание начать"
    },
    {
        id:3,
        name_uz: "Kursni yakunlab men nima olaman?",
        name_ru: "Что я получу, пройдя курс?",
        desc_uz: "Kursni yankunlagandan keyin sizda mobil o'yin yaratish imkoniyati bo'ladi. Shu bilanbirga 3D animatsiya olamiga birinchi qadamni qo'yasiz",
        desc_ru: "После запуска курса у вас будет возможность создать мобильную игру. Таким образом, вы сделаете первый шаг в мир 3D-анимации"
    },
    {
        id:4,
        name_uz: "Qancha vaqta o'yin yarata olaman?",
        name_ru: "Сколько времени я могу создать игру?",
        desc_uz: "Bu o'yinning imkoniyatlariga bog'lik. Dastur tayyor shablonlaridan foydalanib oddiyroq o'yinni 1 kunda yaratish mumkin.",
        desc_ru: "Это зависит от возможностей игры. Более простую игру можно создать за 1 день, используя готовые программные шаблоны."
    },

];
export let web = [
    {
        id: 1,
        title_uz: "Mulokot",
        title_ru: "Диалог",
        desc_uz: "Tanishish, mulokot qilish va tinglash orqali jamoadoshlari bilan konstruktiv mulokot o'rnatish, o'z g'oyalarini yakkol ifodalay olishni o'rganadi",
        desc_ru: "Через знакомство, общение и слушание учится выстраивать конструктивный диалог с товарищами по команде, уметь ярко выражать свои идеи",
    },
    {
        id: 2,
        title_uz: "Muammolarni xal qila bilish",
        title_ru: "Уметь решать проблемы",
        desc_uz: "Murakkab masalalarni qismlarga bo'lib xal qilishni o'rganadi",
        desc_ru: "Учится решать сложные задачи по частям",
    },
    {
        id: 3,
        title_uz: "Vazifalarni to'g'ri qo'ya bilish",
        title_ru: "Уметь правильно ставить задачи",
        desc_uz: "O'z vazifasining asosiy maqsadini aniqlab olishni o'rganadi",
        desc_ru: "Учится определять основную цель своей задачи",
    },
    {
        id: 4,
        title_uz: "Intizom",
        title_ru: "Дисциплина",
        desc_uz: "Shaxsiy resurslarni to'g'ri taqsimlash, muddatlar borasida ulgurish",
        desc_ru: "Правильное распределение личных ресурсов, соблюдение сроков",
    },
    {
        id: 5,
        title_uz: "Moslashuvchanlik",
        title_ru: "Гибкость",
        desc_uz: "Oldingi vazifalar uchun yangicha yondashuvlarni qo'llab, odatiy narsalarni noodatiy tarzda amalga oshirish va vaziyat uchun nostandart yechimlarni yangi sharoitga tezda moshlashishni o'rganishadi",
        desc_ru: "Они учатся по-новому подходить к поставленным задачам, необычно реализовывать привычные вещи и быстро приспосабливать к новым условиям нестандартные для ситуации решения",
    },
];
export let web2 = [
    {
        id: 0,
        title_uz: "Dasturlashning asosiy qismlari o'rgatiladi",
        title_ru: "Основные части программирования преподаются",
        desc_uz: "Ushbu kurs yosh dasturchilarning bor e'tiborini fantaziyaga, fikrlash doirasini kengaytirishga va dasturlash sohasida ko'nikmalarga ega bo'lishida ulkan hissa qo'shadi. Mazkur kursda bolalarga  ijodiy ishlar qilish mobaynida o'z qobilyatlarini o'sishiga , zamon bilan hamnafas bo'lishida hamda IT sohasiga kirishiga ilk qadam bo'ladi.",
        desc_ru: "Этот курс вносит огромный вклад в то, что молодые программисты уделяют все свое внимание фантазии, расширению своего мышления и приобретению навыков программирования. Данный курс станет первым шагом в развитии творческих способностей детей , в ногу со временем и вхождения в сферу IT.",
    },
    {
        id: 1,
        title_uz: "To'g'ri ma'lumot topish",
        title_ru: "Искать правильной информации",
        desc_uz: "O'quvchi kurs davomida o'zini muammolarini to'g'ri va aniq ma'lumotlarni qayerdan topishni va to'g'ri qidirishni o'rganadi. Ma'lumotlarni tahlil qilishga layoqatli bo'ladi. Asosiysi dasturlashdagi o'ziga duch kelgan xatoliklarni izlab o'rganishni, yangi narsalarni topishni bemalol uddalaydi.",
        desc_ru: "На протяжении всего курса студент узнает о своих проблемах, где найти и правильно искать правильную и точную информацию. Он будет способен анализировать данные. Главное, чтобы он мог свободно учиться, находить что-то новое, искать ошибки, с которыми он столкнулся в программировании.",
    },
    {
        id: 2,
        title_uz: "Dasturlashdagi jarayonlar",
        title_ru: "Процессы в программировании",
        desc_uz: "Dasturlash mantiqiy fikrlashga ma'lumotlarni tizimlashga asosiysi jamoa bo'lib ishlashga ko'nikib hamda o'rganib boradi. O'quvchi har bir dars oxirida o'tilgan mavzuga oid kichkina va qiziqarli bo'lgan kichkina sahifaga yasash orqali mavzuni mustahkamlaydi. Darsda raqobat va mulohaza orqali o'z o'zini fikrlash va ko'rsata olish darajasini oshiradi.",
        desc_ru: "Программирование приучает и обучает логическому мышлению, систематизации информации, командной работе. Ученик укрепляет свою тему, делая ее маленькой и интересной страницей, посвященной теме, упомянутой в конце каждого урока. Повышает уровень умения мыслить и проявлять себя на уроке посредством соревнования и рассуждений.",
    },
];
export let foundation = [
    // 0
    [
        {
            id: 1,
            name_uz: "1 - bosqich | 1 oy",
            name_ru: "1 - этап | 1 месяц",
            child : [
                {
                    id:1,
                    detail_item_uz: "Kompyuterning klaviatura buyruklari va qidiruv tizimdan foydalanish",
                    detail_item_ru: "Использование команд клавиатуры компьютера и поисковой системы",
                },
                {
                    id:2,
                    detail_item_uz: "Brauzerlardan xavfsiz foydalanish",
                    detail_item_ru: "Безопасное использование браузеров",
                },
                {
                    id:3,
                    detail_item_uz: "Windows operatsion tizimini qayta o'rnatish",
                    detail_item_ru: "Переустановите операционную систему Windows",
                }
            ]
        },
        {
            id: 2,
            name_uz: "2 - bosqich | 1 oy",
            name_ru: "2 - этап | 1 месяц",
            child: [
                {
                    id:1,
                    detail_item_uz: "Microsoft Word dasturi bilan tanishish",
                    detail_item_ru: "Знакомство с Microsoft Word.",
                },
                {
                    id:2,
                    detail_item_uz: "Klaviaturaning asosiy tugmachalarini o'rgatish",
                    detail_item_ru: "Обучение основным клавишам клавиатуры",
                },
                {
                    id:3,
                    detail_item_uz: "Diagrammalar hosil qilish. PDF hujjat ko'rinishida saqlash",
                    detail_item_ru: "Создание диаграмм. Сохранить как PDF-документ",
                },
                {
                    id:4,
                    detail_item_uz: "Microsoft Excel dasturida shakkilar va diagrammalar bilan ishlash",
                    detail_item_ru: "Работа с формами и диаграммами в Microsoft Excel",
                }
            ]
        },
    ],
]